import LoadMore from "../plugins/load-more";

new LoadMore('.block-related-casestudies', '.block-related-casestudies .load-more');